/**
 * Feature Flags Configuration
 *
 * Controls which features are enabled/disabled in the application.
 * Feature flags are now controlled via environment variables for safer deployment.
 *
 * Environment Variables:
 * - REACT_APP_ENABLE_KOFI: 'true' or 'false' (default: 'false')
 * - REACT_APP_KOFI_USERNAME: Your Ko-fi username (default: '')
 * - REACT_APP_ENABLE_RHP: 'true' or 'false' (default: 'false')
 *
 * Local Development: Set values in frontend/.env.local (not committed to git)
 * Production: Configure in Vercel Dashboard → Settings → Environment Variables
 */

const featureFlags = {
  /**
   * Ko-fi Donation Integration
   *
   * IMPORTANT: Only enable this AFTER Issue #1 (LLC formation) is complete!
   *
   * Requirements before enabling:
   * - LLC must be formed
   * - Business bank account must be set up
   * - Terms of Service must be in place (✅ already done)
   * - Privacy Policy must be in place (✅ already done)
   *
   * To enable: Set REACT_APP_ENABLE_KOFI=true in environment
   */
  ENABLE_KOFI: process.env.REACT_APP_ENABLE_KOFI === 'true',

  /**
   * Your Ko-fi username
   * Example: 'carnivoresadapting' for ko-fi.com/carnivoresadapting
   *
   * Set via REACT_APP_KOFI_USERNAME environment variable
   */
  KOFI_USERNAME: process.env.REACT_APP_KOFI_USERNAME || '',

  /**
   * Reno Horrible People House Rules
   *
   * IMPORTANT: Only enable this AFTER Issue #231 (RHP website) is complete!
   *
   * Requirements before enabling:
   * - All 5 house rules must be implemented and tested (#226-230)
   * - Reno Horrible People website must be live
   * - FAQ must be updated with RHP information
   *
   * When enabled, shows RHP rules section in room creation settings.
   * Individual rules are toggled by room creator per game.
   *
   * To enable: Set REACT_APP_ENABLE_RHP=true in environment
   */
  ENABLE_RHP_RULES: process.env.REACT_APP_ENABLE_RHP === 'true',

  /**
   * Future feature flags can go here
   */
  // ENABLE_TOKEN_CLAIMING: process.env.REACT_APP_ENABLE_TOKEN_CLAIMING === 'true',
  // ENABLE_ADVANCED_ANALYTICS: process.env.REACT_APP_ENABLE_ANALYTICS === 'true',
};

export default featureFlags;
